import { Experiences } from '@/Reservations/Search/Experiences'
import { reservationWidgetMessages } from '@/reservationWidgetMessages'
import { useLocales } from '@sevenrooms/locales'
import type { ThemeSpacing } from '@sevenrooms/ui-kit/theme'
import { Text } from '@sevenrooms/ui-kit/typography'
import type { AvailabilityTimeWithUpSellCost, ExperienceWithAvailability } from '../../../../hooks/useAvailability'
import type { ExperienceCardProps } from '@/Reservations/Search/ExperienceCard'
import type { TimeSlotsProps } from '@/Reservations/Search/ExperienceCard/TimeSlots'

interface OtherPrivateEventsAvailabilityProps {
  experiences?: ExperienceWithAvailability[]
  timeSlotVariant?: ExperienceCardProps['timeSlotVariant']
  direction?: TimeSlotsProps['direction']
  startDate: string
  partySize: number
  isLoading?: boolean
  onTimeSlotClick?: (slot: AvailabilityTimeWithUpSellCost, experience: ExperienceWithAvailability) => void
  onMoreDetailsClick?: (experience: ExperienceWithAvailability) => void
  onShowMoreClick?: () => void
  scrollRightMargin?: ThemeSpacing
  hideRequestButton?: boolean
  useHorizontalScroll?: boolean
}

export function OtherPrivateEventsAvailability({
  experiences,
  startDate,
  partySize,
  timeSlotVariant = 'primary',
  direction = 'row',
  isLoading,
  onTimeSlotClick,
  onMoreDetailsClick,
  onShowMoreClick,
  scrollRightMargin,
  hideRequestButton,
  useHorizontalScroll,
}: OtherPrivateEventsAvailabilityProps) {
  const { formatMessage } = useLocales()
  const experiencesLength = experiences?.length || 0
  if (!experiencesLength && !isLoading) {
    return null
  }
  return (
    <Experiences
      label={
        <Text textStyle="body1Bold" data-test="private-events-group-booking-label">
          {formatMessage(reservationWidgetMessages.resWidgetPrivateEventsGroupBookingLabel)}
        </Text>
      }
      isLoading={isLoading}
      partySize={partySize}
      startDate={startDate}
      experiences={experiences}
      desktopVariant="short"
      descriptionType="short"
      direction={direction}
      timeSlotVariant={timeSlotVariant}
      onTimeSlotClick={onTimeSlotClick}
      onMoreDetailsClick={onMoreDetailsClick}
      onShowMoreClick={onShowMoreClick}
      useHorizontalScroll={useHorizontalScroll}
      scrollRightMargin={scrollRightMargin}
      hideRequestButton={hideRequestButton}
      isPrivateEvents
    />
  )
}
